import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DashboardProfileContextService } from '@rma/dashboard/authentication/public/user';
import { RMA_DEFAULT_HTTP_OPTIONS } from '@rma/dashboard/generic/util/environment';
import { httpParamMapper } from '@rma/dashboard/generic/util/http';
import { appendToRmaSocialApiUrl } from '@rma/generic/ng/util';
import { Observable, switchMap } from 'rxjs';
import { SocialMediaActivityCountModel } from './social-media-activity-count';

// I am not sure what the difference bettwen this and analytics
@Injectable({
  providedIn: 'root',
})
export class SocialAnalyticsApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaSocialApiUrl = inject(appendToRmaSocialApiUrl);
  private readonly profileContextService = inject(DashboardProfileContextService);

  public getMyActivityCountByType(from?: Date, to?: Date): Observable<SocialMediaActivityCountModel> {
    return this.profileContextService.profileIdentifier$.pipe(
      switchMap((context) => {
        const endpoint = this.activityCountsByType(context.profileType, context.profileCode);
        const url = this.rmaSocialApiUrl(endpoint);
        const params = httpParamMapper({ from, to });
        const headers = { ...RMA_DEFAULT_HTTP_OPTIONS, params };

        return this.httpClient.get<SocialMediaActivityCountModel>(url, headers);
      }),
    );
  }
  private activityCountsByType(profileType: string, profileCode: string) {
    return `${profileType}/${profileCode}/activity/counts`;
  }
}
